import { createTextColumn } from '@ipfabric/utils';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { PolicyRowActions } from '../shared/PolicyRowActions';
import type { PolicyRowMode } from '../shared/policyFormMode';
import type { WriteScopes } from '../shared/useWriteScopes';

export type RolesTableV2Row = {
  id: string;
  name: string;
  description: string;
  type: string;
  endpointPolicies: string;
  dataPolicies: string;
  readOnly: boolean;
};

type RolesTableV2Handlers = {
  scopes: WriteScopes;
  onOpen: (roleId: string, mode: PolicyRowMode) => void;
  onDelete: (row: RolesTableV2Row) => void;
};

export const createRolesTableV2Columns = ({
  scopes,
  onOpen,
  onDelete,
}: RolesTableV2Handlers) => [
  createTextColumn<RolesTableV2Row>({ key: 'id', title: 'ID', hidden: true }),
  createTextColumn<RolesTableV2Row>({ key: 'name', title: 'Role name' }),
  createTextColumn<RolesTableV2Row>({
    key: 'description',
    title: 'Description',
  }),
  createTextColumn<RolesTableV2Row>({ key: 'type', title: 'Type' }),
  createTextColumn<RolesTableV2Row>({
    key: 'endpointPolicies',
    title: 'Endpoint policies',
  }),
  createTextColumn<RolesTableV2Row>({
    key: 'dataPolicies',
    title: 'Data policies',
  }),
  createFrontendOnlyColumn<RolesTableV2Row>({
    key: 'actions',
    title: 'Actions',
    disabledSort: true,
    webDependencies: ['id'],
    render: (row) => (
      <PolicyRowActions
        id={row.id}
        testIdPrefix='roles'
        readOnly={row.readOnly}
        scopes={scopes}
        onView={() => onOpen(row.id, 'view')}
        onEdit={() => onOpen(row.id, 'edit')}
        onDuplicate={() => onOpen(row.id, 'duplicate')}
        onDelete={() => onDelete(row)}
      />
    ),
  }),
];
